function drawSearch() {
  console.log('clicked');
  $(".search_drawer").slideToggle();
}


$(document).ready(function() {
  
  setTimeout(function() { 
        $('.standart-product ').addClass('active');
    }, 700);

//   Variant Selection
  $('.option_variants__variant').click(function() {
  
    
  var is_variant_available = 0;  
  var variant_name = $(this).attr('variant_name');
  var option_name = $(this).attr('option_name');
    
//     Auto select for existing variant (TYPE)
    if (variant_name == 'Canvas') {
    
      $('.option_variants__variant').each(function() {
        if ($(this).attr('variant_name') == 'Thin Wrap (0.75' ) {
        $(this).click();
        }
        if ($(this).attr('variant_name') == 'Black Frame' || $(this).attr('variant_name') == 'White Frame' || $(this).attr('variant_name') == 'Print Only') {
        $(this).addClass('disabled_variant');
        }
        else {
        $(this).removeClass('disabled_variant')
      	}
      });
      
    }
    if (variant_name == 'Print') {
    $('.option_variants__variant').each(function() {
        if ($(this).attr('variant_name') == 'Black Frame' ) {
        $(this).click();
        }
      	if ($(this).attr('variant_name') == 'Thin Wrap (0.75' || $(this).attr('variant_name') == 'Thick Wrap (1.5' ) {
        $(this).addClass('disabled_variant');
        }
        else {
        $(this).removeClass('disabled_variant')
      	}
      });
    }
//     Auto select for existing variant (DEPTH)

    
    
   $( ".option_variants" ).each(function() {
     if ($(this).hasClass(option_name)){
       $(this).find('.option_variants__variant').each(function() {
       $(this).removeClass('Added_Variant');
       });
       $(this).find('.option_variants__variant').each(function() {
         if ($(this).attr('variant_name').indexOf(variant_name) > -1) {
       $(this).addClass('Added_Variant');
         }
       });
     }
  });
    
    
//     create full variant string
   let full_variant_name = "variant ";
    
    $('.option_variants__variant').each(function(index) {
      if( $(this).hasClass('Added_Variant') ){
       full_variant_name = full_variant_name + "variant " + index;
        
      }
    });
			variant_indexes = full_variant_name.match(/\d+/g);
            var i=0;
    
    var first_variant_index = variant_indexes[0];
    var second_variant_index = variant_indexes[1];
    var third_variant_index = variant_indexes[2];
    
//     console.log('first isssss', first_variant_index);
//     console.log('second isssss', second_variant_index);
//     console.log('third isssss', third_variant_index);
    
    var first_par;
    var second_par;
    var third_par;
    
    $('.option_variants__variant').each(function(index) {
      if( index == first_variant_index ) {
      first_par = $(this).attr('variant_name');
      }
      if( index == second_variant_index ) {
      second_par = $(this).attr('variant_name');
      }
      if( index == third_variant_index ) {
      third_par = $(this).attr('variant_name');
      }
    });
    
    let full_par = first_par + " / " + second_par + " / " + third_par;
    
    // console.log( full_par );
    
    
    var current_variant_id;
    var current_variant_pos = 1;
    
    $('.Select_variant_variants').each(function() {
    
      if( $(this).attr('variant_name').indexOf(full_par) > -1 )
      {
     	current_variant_id = $(this).attr('value');	
        current_variant_pos = $(this).attr('variant_pos');
        is_variant_available = 1;
      }
      
    });
    
    
    if( is_variant_available == 1 )
    {
//       $('.single-item-slider').slick('slickUnfilter');
//       $('.nav-item-slider').slick('slickUnfilter');
      $('.notification_product').css('margin-top', '0');
      // $('.ppage_notification').text('Black Friday 50% Off Limited Time Offer');
      $('.ppage_price_container').show();
      $('.atc_btn').prop('disabled', false);
      $('.atc_btn').text('Add To Cart');
    $('.selected_variant').attr('value', current_variant_id);
      $('.ppage_price').hide();
      $('.ppage_price_past').hide();
      $('.ppage_price_past').each(function(){
        if($(this).attr('data_id') == current_variant_id) {
        $(this).show();
        }        
      });
      
      $('.ppage_price').each(function(){
        if($(this).attr('data_id') == current_variant_id) {
        $(this).show();
        }        
      });
//       Reset
      $('.variant_asigned_image').each(function(){
     	$(this).removeClass('active-variant');
      });
//       Set Class
      $('.image-item-slick-slider').each(function(){
      if ($(this).attr('variant_id') == current_variant_id )
      {
     	$(this).addClass('active-variant');
      }
      });
//       $('.nav-item-slider-mobile').slick('slickFilter','.active-variant');
//       $('.single-item-slider').slick('slickFilter','.active-variant');
//       $('.nav-item-slider').slick('slickFilter','.active-variant');
//       $('.single-item-slider').slick('slickGoTo', 0);
      
      
//       Checking for image

      var maxImagescount = 0;
      $('.Indexing_image_main').each(function(){
        maxImagescount++;
      });

      maxImagescount = (maxImagescount/2)-1;
      console.log(maxImagescount, 'IMAGESCOUNT');
       console.log( full_par );
      if(full_par.indexOf('Digital') !== -1){
        $('.option_variants.Size').css('opacity', '0.2');
        $('.option_variants.Depth').css('opacity', '0.2');
        $('.option_variants.Depth').addClass('Disabling');
        $('.option_variants.Size').addClass('Disabling');
        $('.ppage_notification').text('Digital Files will be sent to your email address. No physical product will be shipped.');
        
      }
      else if(full_par.indexOf('Canvas') !== -1){
//       Go to first image
        $('.single-item-slider').slick('slickGoTo', maxImagescount+3);
        if ($(window).width() < 960) {
			$('html,body').animate({
            scrollTop: $(".single-item-slider-mobile").offset().top - 80},
            'slow');
		}
        $('.option_variants.Size').css('opacity', '1');
        $('.option_variants.Depth').css('opacity', '1');
        $('.option_variants.Depth').removeClass('Disabling');
        $('.option_variants.Size').removeClass('Disabling');
        $('.ppage_notification').text('Limited Time Offer');
        // $('.option_variants.Size .Option_1').show();
      }
      else if(full_par.indexOf('Print') !== -1){
        $('.option_variants.Size').css('opacity', '1');
        $('.option_variants.Depth').css('opacity', '1');
        $('.option_variants.Depth').removeClass('Disabling');
        $('.option_variants.Size').removeClass('Disabling');
        $('.ppage_notification').text('Limited Time Offer');
        // $('.option_variants.Size .Option_1').hide();
		if(full_par.indexOf('Black') !== -1){
			$('.single-item-slider').slick('slickGoTo', maxImagescount-0);
            if ($(window).width() < 960) {
			$('html,body').animate({
            scrollTop: $(".single-item-slider-mobile").offset().top - 80},
            'slow');
			}
       }
        if(full_par.indexOf('White') !== -1){
			$('.single-item-slider').slick('slickGoTo', maxImagescount-1);
            if ($(window).width() < 960) {
			$('html,body').animate({
            scrollTop: $(".single-item-slider-mobile").offset().top - 80},
            'slow');
			}
       }
        if(full_par.indexOf('Print') !== -1){
			$('.single-item-slider').slick('slickGoTo', maxImagescount-2);
            if ($(window).width() < 960) {
			$('html,body').animate({
            scrollTop: $(".single-item-slider-mobile").offset().top - 80},
            'slow');
			}
       }
      }
      
    }
    else {
    $('.notification_product').css('margin-top', '30px');
    $('.ppage_notification').text('Limited Time Offer')
    // $('.ppage_notification').text('Choose Different Depth Or Type Option');
    setTimeout(function(){
           $('.option_variants.Size .Option_2').trigger('click');
          console.log('CLicked');
    },100);
    // $('.option_variants.Size .Option_1').show();
    $('.ppage_price_container').hide();
    $('.atc_btn').prop('disabled', true);
    $('.atc_btn').text('Unavailable');
    }
    
    $('.Select_variant_variants').each(function() {
    $(this).removeClass('Selected_Variant');
    });
    $('.Select_variant_variants').each(function() {
      if( $(this).attr('variant_name').indexOf(full_variant_name) > -1 ){
    $(this).addClass('Selected_Variant');
      }
    });
     
   
  });
  
//   $('.unfilter-js').click(function() {
// //   alert();
//     $('.single-item-slider').slick('slickUnfilter');
//       $('.nav-item-slider').slick('slickUnfilter');
//   });
  
  $('.Option_1').click();
  
  $('.featured-slick-carousel').slick(

{
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0570/0219/7151/files/Icon_ionic-ios-arrow-back-1_2x_6c329c7e-cedd-4372-9ec1-62bd2ec69f28.png?v=1624880736'/></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0570/0219/7151/files/Icon_ionic-ios-arrow-back_2x_559101dd-e9af-4a2d-84ab-90ede6f5dd51.png?v=1624880736'/></button>",
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
  {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    }]
}
);
  
  
//   Redirect
  if (window.location.href=="https://successhuntersprints.com/products/free-secret-mini-canvas?variant=41003320213663"){
window.location.replace("https://successhuntersprints.com");
}
  

  
  $('.upsell button').addClass('upsell_trigger');
  
//   function makeTimer() {

// 	//		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");	
// 		var endTime = new Date("01 December 2021 21:00:00 GMT+00:00");			
// 			endTime = (Date.parse(endTime) / 1000);

// 			var now = new Date();
// 			now = (Date.parse(now) / 1000);

// 			var timeLeft = endTime - now;

// 			var days = Math.floor(timeLeft / 86400); 
// 			var hours = Math.floor(timeLeft / 3600);
//     		var hours_to_calc = Math.floor((timeLeft - (days * 86400)) / 3600);
// 			var minutes = Math.floor((timeLeft - (days * 86400) - (hours_to_calc * 3600 )) / 60);
// 			var seconds = Math.floor((timeLeft - (days * 86400) - (hours_to_calc * 3600) - (minutes * 60)));
  
// 			if (hours < "10") { hours = "0" + hours; }
// 			if (minutes < "10") { minutes = "0" + minutes; }
// 			if (seconds < "10") { seconds = "0" + seconds; }

  
//   			$("#days2").html(days + "<div>Days</div>");
// 			$("#hours2").html(hours + "<div>Hours</div>");
// 			$("#minutes2").html(minutes + "<div>Minutes</div>");
// 			$("#seconds2").html(seconds + "<div>Seconds</div>");
    
//     		$("#days3").html(days + "<div>Days</div>");
// 			$("#hours3").html(hours + "<div>Hours</div>");
// 			$("#minutes3").html(minutes + "<div>Minutes</div>");
// 			$("#seconds3").html(seconds + "<div>Seconds</div>");
    
    
//     		$("#days4").html(days + "<div>Days</div>");
// 			$("#hours4").html(hours + "<div>Hours</div>");
// 			$("#minutes4").html(minutes + "<div>Minutes</div>");
// 			$("#seconds4").html(seconds + "<div>Seconds</div>");
    
    
//     		$("#days5").html(days + "<div>Days</div>");
// 			$("#hours5").html(hours + "<div>Hours</div>");
// 			$("#minutes5").html(minutes + "<div>Minutes</div>");
// 			$("#seconds5").html(seconds + "<div>Seconds</div>");
    
//     		$("#days6").html(days + "<div>Days</div>");
// 			$("#hours6").html(hours + "<div>Hours</div>");
// 			$("#minutes6").html(minutes + "<div>Minutes</div>");
// 			$("#seconds6").html(seconds + "<div>Seconds</div>");
    
//     		$("#days7").html(days + "<div>Days</div>");
// 			$("#hours7").html(hours + "<div>Hours</div>");
// 			$("#minutes7").html(minutes + "<div>Minutes</div>");
// 			$("#seconds7").html(seconds + "<div>Seconds</div>");
// 	}

// 	setInterval(function() { makeTimer(); }, 1000);



  // Collection card image swatch

  $('.product-card').mouseover(function() {
   $(this).find('.product_card_image_js_next').addClass('product_card_image_js--visible');
   $(this).find('.product_card_image_js_original').removeClass('product_card_image_js--visible');
  });

  $('.product-card').mouseout(function() {
   $(this).find('.product_card_image_js_next').removeClass('product_card_image_js--visible');
   $(this).find('.product_card_image_js_original').addClass('product_card_image_js--visible');
  });


  $('.Footer_text_expand_button').click(function(){
    if ($(this).attr('data-expanded') == 'false'){
      $('.Footer_text_expand_button').text('READ LESS');
      $('.Footer_text_inner_hidden').slideDown();
      $(this).attr('data-expanded','true');
    }
    else{
      $('.Footer_text_expand_button').text('READ MORE');
      $('.Footer_text_inner_hidden').slideUp();
      $(this).attr('data-expanded','false');
      $('html, body').animate({
          scrollTop: $(".Footer_text_inner_visible").offset().top-100
      }, 200);
    }
  });

  $('.sf_close').click(function(){
    $('.sf_outer').hide();
  });

  $(document).on("click","#search_ionn_mobile",function() {
    $('.sf_outer').css('display', 'flex');
  });


  setInterval(function(){
    $('.rewards-tiers-labels-item-amount').each(function(){
      var html = $(this).html();
      if (html == '1 items'){
        $(this).html('1 item'); 
      }
    });


    $('.template-product').css('overflow', '');
    $('html').css('overflow', 'auto');


    jQuery.getJSON("/cart.js", function (cart) {
        // console.log(cart);
          var giftId = 41003320213663;
          var currentQty = cart.item_count;
          var giftQty = 0;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].id == giftId){
              giftQty += cart.items[i].quantity;
            }
          }

      if (currentQty == 3 && giftQty > 0 ){
        var index = 0;
        $('.rewards-tiers-container').each(function(){
          index = index + 1;
          if (index == 2){
            // $(this).find('.rewards-tiers-item-icon').removeClass('rewards-tiers-item-icon-fulfilled');
            // $(this).find('.rewards-tiers-item-icon').removeClass('rewards-tiers-item-icon-unfulfilled');
          }
        });
      }


      // Load progress bar
      if (currentQty < 2){
        $('.pr_offer_element_offer[data="1"]').addClass('active');
        $('.pr_offer_element_offer[data="1"]').removeClass('inactive');
        $('.pr_offer_element_offer[data="2"]').addClass('inactive');
        $('.pr_offer_element_offer[data="3"]').addClass('inactive');
        $('.pr_offer_element_offer[data="3"]').removeClass('active');
        $('.pr_offer_element_offer[data="2"]').removeClass('active');
      }
      else if (currentQty == 2){
        $('.pr_offer_element_offer[data="1"]').addClass('active');
        $('.pr_offer_element_offer[data="1"]').removeClass('inactive');
        $('.pr_offer_element_offer[data="2"]').addClass('active');
        $('.pr_offer_element_offer[data="2"]').removeClass('inactive');
        $('.pr_offer_element_offer[data="3"]').addClass('inactive');
        $('.pr_offer_element_offer[data="3"]').removeClass('active');
      }
      else{
        $('.pr_offer_element_offer[data="1"]').addClass('active');
        $('.pr_offer_element_offer[data="1"]').removeClass('inactive');
        $('.pr_offer_element_offer[data="2"]').addClass('active');
        $('.pr_offer_element_offer[data="2"]').removeClass('inactive');
        $('.pr_offer_element_offer[data="3"]').addClass('active');
        $('.pr_offer_element_offer[data="3"]').removeClass('inactive');
      }
    });
    
  },100);


  $(document).on("click",'[aria-label="close cart"]',function() {
     window.location.reload();
  });
  
});